export const questions = [
  {
    questionNum: 1,
    comprehension:
      "In the questions below, choose the word(s) or phrase which best fills the gap(s) ",
    question:
      " Jubril found that thieves had entered his house in his absence. He went to the police to report the…",

    options: [
      {
        label: "A",
        text: "​break out",
        correct_answer: false,
      },
      { label: "B", text: "break up", correct_answer: false },
      {
        label: "C",
        text: "break in",
        correct_answer: true,
      },
      { label: "D", text: "break into", correct_answer: false },
    ],
    id: 1,

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
  },
  {
    questionNum: 2,
    question:
      "After the accused was found guilty by the court, his counsel… before sentence was passed",
    options: [
      {
        label: "A",
        text: "​begged for mercy",
        correct_answer: false,
      },
      {
        label: "B",
        text: "made a plea for mitigation ",
        correct_answer: true,
      },
      {
        label: "C",
        text: "made an ovation",
        correct_answer: false,
      },
      { label: "D", text: "made a plea for litigation", correct_answer: false },
    ],

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 2,
  },
  {
    questionNum: 3,
    question:
      " Four persons accused of currency … are being held by the security agents.",

    options: [
      {
        label: "A",
        text: "​trafficking",
        correct_answer: false,
      },
      { label: "B", text: "traviking", correct_answer: false },
      {
        label: "C",
        text: "trafficking",
        correct_answer: true,
      },
      { label: "D", text: "traffiking", correct_answer: false },
    ],

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 3,
  },
  {
    questionNum: 4,
    question: "Gone are the days when he… enjoy patronage.",

    options: [
      {
        label: "A",
        text: "would",
        correct_answer: false,
      },
      { label: "B", text: "will", correct_answer: false },
      {
        label: "C",
        text: "used",
        correct_answer: true,
      },
      { label: "D", text: "​could", correct_answer: false },
    ],
    id: 4,

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
  },
  {
    questionNum: 5,
    question: "He did not attend the final burial …",

    options: [
      {
        label: "A",
        text: "rite",
        correct_answer: false,
      },
      { label: "B", text: "rights", correct_answer: false },
      {
        label: "C",
        text: "rites",
        correct_answer: true,
      },
      { label: "D", text: "right", correct_answer: false },
    ],

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 5,
  },
  {
    questionNum: 6,
    question: "The officer was compelled to… the suspect’s car.",
    options: [
      {
        label: "A",
        text: "seize",
        correct_answer: true,
      },
      { label: "B", text: "cease", correct_answer: false },
      {
        label: "C",
        text: "sieze",
        correct_answer: false,
      },
      { label: "D", text: "​sease", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 6,
  },
  {
    questionNum: 7,
    question:
      "A number of doctors are not so well disposed to … in government hospitals these days, … they?",

    options: [
      {
        label: "A",
        text: "working/do",
        correct_answer: false,
      },
      { label: "B", text: "work/are", correct_answer: false },
      {
        label: "C",
        text: "working/are",
        correct_answer: true,
      },
      { label: "D", text: "work/aren’t", correct_answer: false },
    ],
    id: 7,

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
  },
  {
    questionNum: 8,
    question: "If you are going to the market, may I… please?",
    options: [
      {
        label: "A",
        text: "follow you",
        correct_answer: false,
      },
      { label: "B", text: "come with you", correct_answer: true },
      {
        label: "C",
        text: "come by you",
        correct_answer: false,
      },
      { label: "D", text: "come as your second", correct_answer: false },
    ],

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 8,
    selected: null,
  },
  {
    questionNum: 9,
    question: "Wada said that two of his chickens … eggs yesterday morning.",
    options: [
      {
        label: "A",
        text: "​layed",
        correct_answer: true,
      },
      { label: "B", text: "lied", correct_answer: false },
      {
        label: "C",
        text: "​laid",
        correct_answer: false,
      },
      { label: "D", text: "​lain", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 9,
  },
  {
    questionNum: 10,
    question: "Thank you for the party, we really…",
    options: [
      {
        label: "A",
        text: "enjoyed ourselves",
        correct_answer: false,
      },
      { label: "B", text: "enjoyed", correct_answer: true },
      {
        label: "C",
        text: "enjoyed very much",
        correct_answer: false,
      },
      { label: "D", text: "enjoyed too much.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 10,
  },
  {
    questionNum: 11,
    comprehension:
      "In questions below, choose the option nearest in meaning to the word(s) or phrase underlined,   ",
    question:
      "The culprits will surrender their loot to the customs officials.",
    options: [
      {
        label: "A",
        text: "​give away",
        correct_answer: false,
      },
      { label: "B", text: "give out", correct_answer: false },
      {
        label: "C",
        text: "give in",
        correct_answer: true,
      },
      { label: "D", text: "give up.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 11,
  },
  {
    questionNum: 12,
    question: "​The discussion became animated.",

    options: [
      {
        label: "A",
        text: "specialized",
        correct_answer: false,
      },
      { label: "B", text: "lively", correct_answer: true },
      {
        label: "C",
        text: "​intellectual",
        correct_answer: false,
      },
      { label: "D", text: "unruly", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 12,
  },
  {
    questionNum: 13,
    question: "Rich citizens are often niggardly in their ways",

    options: [
      {
        label: "A",
        text: "beggarly",
        correct_answer: false,
      },
      { label: "B", text: "sordid", correct_answer: false },
      {
        label: "C",
        text: "miserly",
        correct_answer: true,
      },
      { label: "D", text: "pompous", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 13,
  },
  {
    questionNum: 14,
    question: "The musician’s popularity is beginning to decline.",

    options: [
      {
        label: "A",
        text: "change",
        correct_answer: false,
      },
      { label: "B", text: "wane", correct_answer: true },
      {
        label: "C",
        text: "slide",
        correct_answer: false,
      },
      { label: "D", text: "disappear", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 14,
  },
  {
    questionNum: 15,
    question: "Olu promised to look out for her next time he is in town",
    options: [
      {
        label: "A",
        text: "watch for",
        correct_answer: false,
      },
      { label: "B", text: "visit", correct_answer: true },
      {
        label: "C",
        text: "greet",
        correct_answer: false,
      },
      { label: "D", text: "take care of", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 15,
  },
  {
    questionNum: 16,
    question: "Finally, I assured him that I would not go back on my word.",
    options: [
      {
        label: "A",
        text: "return to a place",
        correct_answer: false,
      },
      {
        label: "B",
        text: "return to a certain word when reading",
        correct_answer: false,
      },
      {
        label: "C",
        text: "​re-use my word",
        correct_answer: false,
      },
      { label: "D", text: "fail to keep my promise ", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 16,
  },
  {
    questionNum: 17,
    question:
      "The speaker took his audience down memory lane before he went to the topic of his lecture.",
    options: [
      {
        label: "A",
        text: "took his audience on a journey through a street called Memory Lane",
        correct_answer: false,
      },
      {
        label: "B",
        text: "recalled events from the past ",
        correct_answer: true,
      },
      {
        label: "C",
        text: "​told a tale about a place called Memory Lane",
        correct_answer: false,
      },
      {
        label: "D",
        text: "gave an outline of his lecture",
        correct_answer: false,
      },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 17,
  },
  {
    questionNum: 18,
    comprehension:
      "Choose the option that has the same vowel sound as the one represented by the letters underlined,  ",
    question: " faeces",

    options: [
      {
        label: "A",
        text: "​polices",
        correct_answer: false,
      },
      { label: "B", text: "​pain", correct_answer: false },
      {
        label: "C",
        text: "peasant",
        correct_answer: true,
      },
      { label: "D", text: "pear", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 18,
  },
  {
    questionNum: 19,
    question: "pot",
    options: [
      {
        label: "A",
        text: "port",
        correct_answer: false,
      },
      { label: "B", text: "word", correct_answer: false },
      {
        label: "C",
        text: "correct",
        correct_answer: false,
      },
      { label: "D", text: "​what", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 19,
  },
  {
    questionNum: 20,
    question: "leopard",
    options: [
      {
        label: "A",
        text: "geology",
        correct_answer: false,
      },
      { label: "B", text: "people", correct_answer: false },
      {
        label: "C",
        text: "​leaven",
        correct_answer: false,
      },
      { label: "D", text: "led (Noun)", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 20,
  },
  {
    questionNum: 21,
    comprehension:
      "Select the word that has the same pattern of stress as the given word,  ",
    question: "EDUCATION",
    options: [
      {
        label: "A",
        text: "duplicity",
        correct_answer: false,
      },
      { label: "B", text: "​conjectural", correct_answer: false },
      {
        label: "C",
        text: "economics",
        correct_answer: true,
      },
      { label: "D", text: "elaborate", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 21,
  },
  {
    questionNum: 22,
    question: "HONOUR",
    options: [
      {
        label: "A",
        text: "​human",
        correct_answer: false,
      },
      { label: "B", text: "hyena", correct_answer: false },
      {
        label: "C",
        text: "​humane",
        correct_answer: false,
      },
      { label: "D", text: "hotel ", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 22,
  },
  {
    questionNum: 23,
    question:
      "Identify the word that has a different stress pattern from the others.",

    options: [
      {
        label: "A",
        text: "discourse",
        correct_answer: true,
      },
      { label: "B", text: "​intimate", correct_answer: false },
      {
        label: "C",
        text: "accelerate",
        correct_answer: false,
      },
      { label: "D", text: "integral", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 23,
  },
  {
    questionNum: 24,
    question: "Identify the word that has the stress on the second syllable.",

    options: [
      {
        label: "A",
        text: "​always",
        correct_answer: false,
      },
      { label: "B", text: "result ", correct_answer: true },
      {
        label: "C",
        text: "​reproduce",
        correct_answer: false,
      },
      { label: "D", text: "understand", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 24,
  },
  {
    questionNum: 25,
    comprehension:
      "Choose the options opposite in meaning to the word(s) or phrase in italics. ",
    question:
      "Common sense requires that one should be decorous at formal gatherings.",
    options: [
      {
        label: "A",
        text: "courteous",
        correct_answer: false,
      },
      { label: "B", text: "careful", correct_answer: false },
      {
        label: "C",
        text: "impolite ",
        correct_answer: true,
      },
      { label: "D", text: "incurious", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 25,
  },
  {
    questionNum: 26,
    question: "The string was taut",
    options: [
      {
        label: "A",
        text: "​stretched",
        correct_answer: false,
      },
      { label: "B", text: "loose ", correct_answer: true },
      {
        label: "C",
        text: "​firm",
        correct_answer: false,
      },
      { label: "D", text: "tight", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 26,
  },
  {
    questionNum: 27,
    question:
      "The diminutive figure bounces over the track with unfathomable lightness",
    options: [
      {
        label: "A",
        text: "irresistible",
        correct_answer: false,
      },
      { label: "B", text: "predictable ", correct_answer: true },
      {
        label: "C",
        text: "invigorating",
        correct_answer: false,
      },
      { label: "D", text: "​impressive.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 27,
  },
  {
    questionNum: 28,
    question:
      "The teacher announced that the class would be making a fleeting visit to the Zoo.",
    options: [
      {
        label: "A",
        text: "​long",
        correct_answer: true,
      },
      { label: "B", text: "routine", correct_answer: false },
      {
        label: "C",
        text: "brief",
        correct_answer: false,
      },
      { label: "D", text: "guided", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 28,
  },
  {
    questionNum: 29,
    question: "We intend to make the reception a diurnal event",

    options: [
      {
        label: "A",
        text: "an annual",
        correct_answer: false,
      },
      { label: "B", text: "a weekly", correct_answer: false },
      {
        label: "C",
        text: "a nightly ",
        correct_answer: true,
      },
      { label: "D", text: "a short.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 29,
  },
  {
    questionNum: 30,
    question: "​The project is designed to alleviate poverty in the country.",

    options: [
      {
        label: "A",
        text: "exacerbate",
        correct_answer: true,
      },
      { label: "B", text: "assuage", correct_answer: false },
      {
        label: "C",
        text: "​eradicate",
        correct_answer: false,
      },
      { label: "D", text: "tackle.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 30,
  },
  {
    questionNum: 31,
    question: "The permanent Secretary left his job under a cloud",
    options: [
      {
        label: "A",
        text: "with a clear record",
        correct_answer: true,
      },
      { label: "B", text: "on a sunny day", correct_answer: false },
      {
        label: "C",
        text: "​in disgrace",
        correct_answer: false,
      },
      { label: "D", text: "​on a cloudy clay.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 31,
  },
  {
    questionNum: 32,
    question: "It is surprising that this politician has now turned renegade",
    options: [
      {
        label: "A",
        text: "militant",
        correct_answer: false,
      },
      { label: "B", text: "loyal", correct_answer: true },
      {
        label: "C",
        text: "quiet",
        correct_answer: false,
      },
      { label: "D", text: "corrupt.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 32,
  },
  {
    questionNum: 33,
    question:
      "Hypertension is a debilitating disease that everyone should prevent.",
    options: [
      {
        label: "A",
        text: "a horrible",
        correct_answer: false,
      },
      { label: "B", text: "an enervating", correct_answer: false },
      {
        label: "C",
        text: "a mortal",
        correct_answer: false,
      },
      { label: "D", text: "an energizing", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 33,
  },
  {
    questionNum: 34,
    question:
      "The striking workers have vowed not to return to work until the decision is rescinded",
    options: [
      {
        label: "A",
        text: "​implemented ",
        correct_answer: true,
      },
      { label: "B", text: "changed", correct_answer: false },
      {
        label: "C",
        text: "dismissed",
        correct_answer: false,
      },
      { label: "D", text: "incorporated", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 34,
  },
  {
    questionNum: 35,
    question: "It is rare for a leader and his deputy to see eye to eye.",
    options: [
      {
        label: "A",
        text: "reproach each other",
        correct_answer: false,
      },
      { label: "B", text: "​disagree", correct_answer: false },
      {
        label: "C",
        text: "be of one mind",
        correct_answer: true,
      },
      { label: "D", text: "respect each other.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 35,
  },
  {
    questionNum: 36,
    comprehension:
      "Choose the option nearest in meaning to the word(s) or phrase in italics. ",
    question:
      " The man was able to persuade his wilful and obstinate daughter to follow the career he chose for her",
    options: [
      {
        label: "A",
        text: "​intelligent but arrogant",
        correct_answer: false,
      },
      {
        label: "B",
        text: "hardworking and intelligent",
        correct_answer: false,
      },
      {
        label: "C",
        text: "unyielding and obdurate",
        correct_answer: true,
      },
      { label: "D", text: "​obscure and odious.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 36,
  },
  {
    questionNum: 37,
    question: "That punch by the young boxer proved to be fatal.",
    options: [
      {
        label: "A",
        text: "effective",
        correct_answer: false,
      },
      { label: "B", text: "​belated", correct_answer: false },
      {
        label: "C",
        text: "hard",
        correct_answer: false,
      },
      { label: "D", text: "deadly ", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 37,
  },
  {
    questionNum: 38,
    question:
      "​The boy was told that lie would need several more pints of blood if he was to survive.",
    options: [
      {
        label: "A",
        text: "plenty",
        correct_answer: false,
      },
      { label: "B", text: "​much ", correct_answer: true },
      {
        label: "C",
        text: "many",
        correct_answer: false,
      },
      { label: "D", text: "some", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 38,
  },
  {
    questionNum: 39,
    question:
      "In spite of her grim situation, the young widow smiled dutifully at the visitor’s pleasantries",
    options: [
      {
        label: "A",
        text: "unkind comments",
        correct_answer: false,
      },
      { label: "B", text: "sad stories", correct_answer: false },
      {
        label: "C",
        text: "​condolence messages",
        correct_answer: false,
      },
      { label: "D", text: "jocular remarks", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 39,
  },
  {
    questionNum: 40,
    question:
      "The presence of the security men in the area will provide a moment of respite for the residents.",
    options: [
      {
        label: "A",
        text: "​enduring reprieve",
        correct_answer: false,
      },
      { label: "B", text: "temporary relief", correct_answer: true },
      {
        label: "C",
        text: "lasting security",
        correct_answer: false,
      },
      { label: "D", text: "soothing relaxation.", correct_answer: false },
    ],
    id: 40,

    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
  },
  {
    questionNum: 41,
    question:
      "Though David’s condition is serious, his life is not in immediate danger.",
    options: [
      {
        label: "A",
        text: "grave",
        correct_answer: true,
      },
      { label: "B", text: "nasty", correct_answer: false },
      {
        label: "C",
        text: "dangerous",
        correct_answer: false,
      },
      { label: "D", text: "hypertensive", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 41,
  },
  {
    questionNum: 42,
    question: "The essay topic is nebulous.",
    options: [
      {
        label: "A",
        text: "​clear",
        correct_answer: false,
      },
      { label: "B", text: "​incorrect", correct_answer: false },
      {
        label: "C",
        text: "vague",
        correct_answer: true,
      },
      { label: "D", text: "distinct", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 42,
  },
  {
    questionNum: 43,
    question:
      "I have always believed that my mother is very impassioned woman.",
    options: [
      {
        label: "A",
        text: "impartial",
        correct_answer: false,
      },
      { label: "B", text: "emotional", correct_answer: true },
      {
        label: "C",
        text: "​Impassive",
        correct_answer: false,
      },
      { label: "D", text: "emotive.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 43,
  },
  {
    questionNum: 44,
    question: "My father was at the apogee of his career when he was retired",
    options: [
      {
        label: "A",
        text: "terminal point",
        correct_answer: false,
      },
      { label: "B", text: "​least productive stage", correct_answer: false },
      {
        label: "C",
        text: "redundant stage",
        correct_answer: false,
      },
      { label: "D", text: "highest poin", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 44,
  },
  {
    questionNum: 45,
    question:
      "The party’s gathering was thrown into a state of euphoria after the election result was announced.",
    options: [
      {
        label: "A",
        text: "pleasure",
        correct_answer: false,
      },
      { label: "B", text: "confusion", correct_answer: false },
      {
        label: "C",
        text: "sadness",
        correct_answer: false,
      },
      { label: "D", text: "excitement ", correct_answer: true },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 45,
  },
  {
    questionNum: 46,
    comprehension:
      "Select the option that best explains the information conveyed in the sentence. ",
    question: "The politician’s inflammatory remarks were heavily criticized",
    options: [
      {
        label: "A",
        text: "​The politician’s provocative remarks were heavily criticized ",
        correct_answer: true,
      },
      {
        label: "B",
        text: "The politician’s tribalistic remarks were heavily criticized",
        correct_answer: false,
      },
      {
        label: "C",
        text: "The politician’s bombastic remarks were heavily criticized",
        correct_answer: false,
      },
      {
        label: "D",
        text: "The politician’s rude remarks were heavily criticized",
        correct_answer: false,
      },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 46,
  },
  {
    questionNum: 47,
    question:
      "The events of last Friday show that there is no love lost between the Principal and the Vice- Principal.",
    options: [
      {
        label: "A",
        text: "They dislike each other ",
        correct_answer: true,
      },
      { label: "B", text: "They like each other", correct_answer: false },
      {
        label: "C",
        text: "They cannot part company",
        correct_answer: false,
      },
      { label: "D", text: "They work independently.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 47,
  },
  {
    questionNum: 48,
    question:
      "Though he is our elected representative, he often takes a rather jaundiced view of our problems.",
    options: [
      {
        label: "A",
        text: "He takes a rather hazy view of our problems",
        correct_answer: false,
      },
      {
        label: "B",
        text: "He takes a sickly view of our problems",
        correct_answer: false,
      },
      {
        label: "C",
        text: "He takes an unfavourable position concerning our problems ",
        correct_answer: true,
      },
      {
        label: "D",
        text: "He takes a rather forceful view of our problems.",
        correct_answer: false,
      },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 48,
  },
  {
    questionNum: 49,
    question: "If he were here it could be more fun.",
    options: [
      {
        label: "A",
        text: "There was no fun because he was not present",
        correct_answer: false,
      },
      {
        label: "B",
        text: "He did not show up and so the occasion lacked much fun",
        correct_answer: false,
      },
      {
        label: "C",
        text: "He was being expected to supply more fun",
        correct_answer: false,
      },
      {
        label: "D",
        text: "He was expected but did not show up to liven up the occasion.",
        correct_answer: true,
      },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 49,
  },
  {
    questionNum: 50,
    comprehension:
      "Fill each gap with the most appropriate option from the list provide",
    question:
      "Without our relentless campaigns, we might … victory in the race for the National Assembly",
    options: [
      {
        label: "A",
        text: "never had been",
        correct_answer: false,
      },
      { label: "B", text: "never have been ", correct_answer: true },
      {
        label: "C",
        text: "​have never be",
        correct_answer: false,
      },
      { label: "D", text: "be never sure of.", correct_answer: false },
    ],
    yourAnswer: "6 moles of neon",
    correctAnswer: "6 moles of neon",
    markObtained: 1,
    answerExplanation:
      "To determine the total number of atoms in each option, we’ll multiply the number of moles given by Avogadro’s number, which is 6.022×10236.022×1023 atoms/mole. However, for diatomic molecules like oxygen (O₂) and chlorine (Cl₂), and molecules like ethane (C₂H₆), we’ll need to consider the number of atoms in one molecule. ",
    difficulty: "easy",
    bg: "#5EAA42",
    bg2: "#C7D8FA",
    status: "Correct",
    id: 50,
  },
];
